import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "main-content-container overflow-hidden",
  id: "audio_control2"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-xxl-8" }
const _hoisted_4 = { class: "col-xxl-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = { class: "col-lg-4" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-xxl-8" }
const _hoisted_10 = { class: "col-xxl-4" }
const _hoisted_11 = { class: "row" }
const _hoisted_12 = { class: "col-xl-5 col-xxl-6 col-lg-5" }
const _hoisted_13 = { class: "col-xl-7 col-xxl-6 col-lg-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Featured = _resolveComponent("Featured")!
  const _component_PopularHosts = _resolveComponent("PopularHosts")!
  const _component_RecentlyPlayed = _resolveComponent("RecentlyPlayed")!
  const _component_Player = _resolveComponent("Player")!
  const _component_MostPopular = _resolveComponent("MostPopular")!
  const _component_UpcomingEpisodes = _resolveComponent("UpcomingEpisodes")!
  const _component_TodayEarningsChart = _resolveComponent("TodayEarningsChart")!
  const _component_ListenerAnalyticsChart = _resolveComponent("ListenerAnalyticsChart")!
  const _component_TopPodcasts = _resolveComponent("TopPodcasts")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Featured)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_PopularHosts)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_RecentlyPlayed)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_Player)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_MostPopular)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_UpcomingEpisodes),
        _createVNode(_component_TodayEarningsChart)
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_ListenerAnalyticsChart)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_TopPodcasts)
      ])
    ])
  ]))
}